"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NextPageEdit;

var _element = require("@wordpress/element");

var _i18n = require("@wordpress/i18n");

var _blockEditor = require("@wordpress/block-editor");

/**
 * WordPress dependencies
 */
function NextPageEdit() {
  return (0, _element.createElement)("div", (0, _blockEditor.useBlockProps)(), (0, _element.createElement)("div", {
    className: "wp-block-nextpage"
  }, (0, _element.createElement)("span", null, (0, _i18n.__)('Page break'))));
}
//# sourceMappingURL=edit.js.map